/**
 * MRP Model Forecasts (/mrp/model-forecasts) — input page.
 *
 * Pivot view + inline edit + template download + bulk upload.
 */
import MRPDashboard from '@/pages/MRPDashboard';

export default function MRPModelForecasts() {
  return <MRPDashboard view="model-forecasts" />;
}
